
import {FaLinkedin, FaGithub, FaTwitter, FaInstagram} from 'react-icons/fa'
import React, {useContext} from 'react'
import { LinkContext } from '../provider/provider'

function Socials() {
    const {data, loading} = useContext(LinkContext);
  return (
    <div className='socials'>
         { data.socials.linkedin !== "" ?
        <div className="social">
          <a href={data.socials.linkedin} > <FaLinkedin size={25} /> </a> 
        </div>
        :null }
           { data.socials.instagram !== "" ?
        <div className="social">
          <a href={data.socials.instagram} > <FaInstagram size={25} /> </a> 
        </div>
        :null}
        { data.socials.twitter !== "" ?
            <div className="social">
            <a href={data.socials.twitter} > <FaTwitter size={25} /> </a> 
          </div> : null
        }
        { data.socials.github !== "" ?
        <div className="social">
          <a href={data.socials.github} > <FaGithub size={25} /> </a> 
        </div>
        :null}
    </div>

  )
}

export default Socials